import { render, staticRenderFns } from "./products-ranking-list.component.vue?vue&type=template&id=883ec734&scoped=true"
import script from "./products-ranking-list.component.vue?vue&type=script&lang=ts"
export * from "./products-ranking-list.component.vue?vue&type=script&lang=ts"
import style0 from "./products-ranking-list.component.vue?vue&type=style&index=0&id=883ec734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ec734",
  null
  
)

export default component.exports